import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import { deleteVisitorInvitation } from "../../../axios/Visitor/VisitorApi";

const RemoveInvitationDialog = ({ dataInfo, id, onClose, onRefresh }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose?.();
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const payload = {
        langId: localStorage.getItem("i18nextLngId"),
        eventId: dataInfo?.id,
        id,
      };
      const response = await deleteVisitorInvitation(payload);

      if (response?.status === 200) {
        toast.success(t("common.delete-invitation-successfully"));
        onRefresh?.();
        onClose?.();
      } else {
        toast.error(response?.data?.message || t("common.error"));
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || t("common.network-or-server-error")
      );
      console.error("Delete invitation error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.delete-invitation")}
      subtitle={t("common.are-you-sure-delete-this-invitation")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleDelete}
    />
  );
};

export default RemoveInvitationDialog;
